import { useLocale } from "../context/LocaleContext";
import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

export default function Footer() {
  const { t } = useLocale();
  return (
    <footer
      className="mt-4 border-t px-6 py-4 lg:px-10"
      style={{ borderColor: "var(--sy-border)", background: "var(--sy-bg-2)" }}
    >
      <div className="flex flex-col items-center justify-between gap-3 sm:flex-row">
        <div className="flex items-center gap-3">
          <Link to="/" aria-label={t("Ana Sayfa")}>
            <img
              src="/sayyadi-logo-dark.png"
              alt="Sayyâdî"
              className="h-9 w-auto select-none transition-opacity hover:opacity-85"
              draggable={false}
            />
          </Link>
          <span style={{ color: "var(--sy-border)" }}>|</span>
          <span className="text-xs tracking-[0.18em]" style={{ color: "var(--sy-text-dim)" }}>
            {t("İlim · Sohbet · İrfan")}
          </span>
        </div>

      </div>
      <nav aria-label="Sayyâdi sosyal medya" className="mt-3 flex flex-wrap justify-center gap-3 text-xs" style={{ color: "var(--sy-text-dim)" }}>
        <a className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center gap-2 rounded-full border px-3 transition-colors hover:text-[color:var(--sy-gold)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2" style={{borderColor:"var(--sy-border)"}} href="https://www.instagram.com/sayyadi.platform/" target="_blank" rel="noopener noreferrer"><Instagram size={18} aria-hidden="true"/><span className="sr-only sm:not-sr-only">Instagram</span><span className="sr-only"> (yeni sekmede açılır)</span></a>
        <a className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center gap-2 rounded-full border px-3 transition-colors hover:text-[color:var(--sy-gold)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2" style={{borderColor:"var(--sy-border)"}} href="https://www.facebook.com/profile.php?id=61594965879085" target="_blank" rel="noopener noreferrer"><Facebook size={18} aria-hidden="true"/><span className="sr-only sm:not-sr-only">Facebook</span><span className="sr-only"> (yeni sekmede açılır)</span></a>
      </nav>
      <nav aria-label={t("Hukuki bilgiler")} className="mt-4 flex flex-wrap justify-center gap-5 text-xs underline" style={{ color: "var(--sy-text-dim)" }}>
        <Link to="/gizlilik">{t("Gizlilik Politikası")}</Link>
        <Link to="/veri-silme">{t("Veri Silme")}</Link>
        <Link to="/kullanim-kosullari">{t("Kullanım Koşulları")}</Link>
      </nav>
        <div data-testid="footer-credit" className="mt-3 flex items-center justify-end gap-1" style={{ color: "var(--sy-text-dim)" }}>
          <span className="font-hand text-[10px] leading-none pt-1">Powered by</span>
          <span
            className="font-hand text-[12px] leading-none pt-1"
            style={{ color: "var(--sy-text-dim)" }}
          >
            Derviş Yavuz
          </span>
        </div>
    </footer>
  );
}

